@if (loading) {
  <div class="row g-4 mb-4">
    @for (_ of [1,2,3,4]; track _) {
      <div class="col-md-3">
        <div class="loading-skeleton skeleton-stat"></div>
      </div>
    }
  </div>
  <div class="row g-4">
    @for (_ of [1,2,3]; track _) {
      <div class="col-md-4">
        <div class="loading-skeleton skeleton-agg"></div>
      </div>
    }
  </div>
} @else if (error) {
  <div class="d-flex flex-column align-items-center justify-content-center py-5">
    <i class="fa-solid fa-circle-exclamation fs-1 text-danger mb-3"></i>
    <h4 class="text-muted">Echec du chargement du tableau de bord</h4>
    <p class="text-muted">Veuillez reessayer plus tard.</p>
  </div>
} @else {
  <!-- Row 1: Stats -->
  <div class="row g-4 mb-5">
    @for (card of totalCards; track card.label) {
      <div class="col-md-3 col-sm-6">
        <div class="card stat-card shadow-sm h-100" [style.border-left]="'4px solid ' + card.color">
          <div class="card-body d-flex align-items-center gap-3">
            <div class="stat-icon-circle d-flex align-items-center justify-content-center"
                 [style.background]="card.color + '18'"
                 [style.color]="card.color">
              <i [class]="card.icon"></i>
            </div>
            <div class="stat-info">
              <span class="stat-label text-uppercase">Total {{ card.label }}</span>
              <span class="stat-number d-block" [style.color]="card.color">
                {{ card.value == null ? '0.0' : (card.value | number:'1.0-3') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Row 2: Aggregate Sections -->
  <h5 class="section-heading mb-3">
    <i class="fa-solid fa-chart-bar me-2"></i>Indicateurs
  </h5>
  <div class="row g-4">
    @for (section of aggregateSections; track section.title) {
      <div class="col-md-4 col-sm-6">
        <div class="card agg-card shadow-sm">
          <div class="agg-card-header d-flex align-items-center">
            <i class="fa-solid fa-table me-2" style="color: #ffffff;"></i>
            <span>{{ section.title }}</span>
          </div>
          <div class="agg-card-body">
            @if (section.data.length === 0) {
              <div class="agg-empty text-center text-muted py-4">
                <i class="fa-solid fa-database fs-4 mb-2 d-block"></i>
                 <small>Aucune donnee disponible</small>
               </div>
            } @else {
              @for (row of section.data; track row.name; let i = $index) {
                <div class="agg-row d-flex justify-content-between align-items-center" [class.agg-row-alt]="i % 2 !== 0">
                  <span class="agg-name">{{ row.name }}</span>
                  <span class="agg-value">{{ row.total | number:'1.0-2' }}</span>
                </div>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
}
